import { Context } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import GeoJsonPointer from "./GeoJsonPointer.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.imagine.map.EditGeoJsonPointer');
const create = opts => {
  const {
    relationship,
    attribute
  } = opts;
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `blueprint.action.${path}.google.EditGeoJsonPointer`,
    name: tf('name', {
      blueprintName: blueprint.name,
      attributeName: attribute.name
    }),
    handles: cxt => {
      // maybe check allows
      return Context.isTargetOfType(cxt, blueprint.type);
    },
    appearance: data => {
      return {
        name: t('name', {
          blueprintName: blueprint.name,
          attributeName: attribute.name
        }),
        icon: tIcon('editIcon', 'fa fa-plus fa-fw')
      };
    },
    perform: ({
      context
    }) => {
      const target = Context.getTargetOfType(context, blueprint.type);
      const {
        mapViewer,
        clientProps: {
          delegate,
          relationship
        }
      } = context;
      let feature = context.feature;
      if (typeof feature === 'string') {
        try {
          feature = JSON.parse(feature);
        } catch {
          feature = null;
        }
      }
      if (target == null || mapViewer == null || delegate == null || relationship == null) {
        return;
      }
      mapViewer.setPointer(new GeoJsonPointer({
        ...opts,
        relationship,
        delegate: DataSources.getActions(target),
        mapViewer,
        target,
        attribute,
        feature: feature == null ? null : feature,
        map: mapViewer.map
      }));
    }
  };
};
export default {
  create
};